/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Shared layouts
import { Dashboard as DashboardLayout } from 'layouts';

import { Portlet, PortletHeader, PortletContent } from 'components';

// Material helpers
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from '@mui/material';

// Material components
import { Button, Grid2, TextField } from '@mui/material';

// Component styles
import styles from './styles';
import {
  showCountrySates,
  showCities,
  showCPS,
  showCounties,
} from 'js/actions/zepomexActions';
import {
  getDataInvoiceCharge,
  updateDataInvoiceCharge,
} from 'js/actions/chargeActions';
import { makeStyles } from '@mui/styles';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import {
  showCFDI,
  showPaymentMethods,
  showPaymentTypes,
} from 'js/actions/invoiceActions';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles(styles);

function useOnMount(handler) {
  return React.useEffect(handler, []);
}

export default function ChargeInvoiceData() {
  const { charge, groupId } = useLocation().state;

  const { register, handleSubmit } = useForm();
  const classes = useStyles();
  const dispatch = useDispatch();

  const [rfc, setRfc] = useState();
  const [razonSocial, setRazonSocial] = useState();
  const [cfdi, setCfdi] = useState();
  const [tipoDePago, setTipoDePago] = useState();
  const [metodoDePago, setMetodoDePago] = useState();

  const [state, setState] = useState();
  const [city, setCity] = useState();

  const [calle, setCalle] = useState();
  const [cp, setCP] = useState();
  const [numExt, setNumExt] = useState();
  const [colonia, setColonia] = useState();

  const estados = useSelector((state) => state.zepomex.states.estado);
  const cities = useSelector((state) => state.zepomex.cities.municipios);
  const cps = useSelector((state) => state.zepomex.cp.cp);
  const counties = useSelector((state) => state.zepomex.counties.colonia);

  const payment_types = useSelector((state) => state.invoice.payment_types);
  const payment_methods = useSelector((state) => state.invoice.payment_methods);
  const cfdis = useSelector((state) => state.invoice.cfdi);

  /*
  const [cfdi_form, setCfdiForm] = useState()
  const [payment_types_form, setPaymentTypeForm] = useState()
  const [payment_methods_form, setPaymentMethodForm] = useState()
*/

  const handleCFDI = (cfdi) => {
    setCfdi(cfdi.target.value);
  };

  const handlePaymentTypes = (payment_type) => {
    setTipoDePago(payment_type.target.value);
  };

  const handlePaymentMethods = (payment_methods) => {
    setMetodoDePago(payment_methods.target.value);
  };

  const handleChangeState = (state) => {
    setState(state.target.value);
    getCity(state.target.value);
  };

  const getCity = (state) => {
    dispatch(showCities(state));
  };

  const handleChangeCity = (city) => {
    setCity(city.target.value);
  };

  useOnMount(() => {
    dispatch(showCountrySates());
  });

  useEffect(() => {
    dispatch(showCFDI());
    dispatch(showPaymentTypes());
    dispatch(showPaymentMethods());
    dispatch(getDataInvoiceCharge(charge.id, responseGetChargeDataInvoice));
  }, []);

  const responseGetChargeDataInvoice = (data) => {
    setRfc(data.rfc);
    setRazonSocial(data.razon_social);
    setCfdi(data.cfdi);
    setTipoDePago(data.tipo_de_pago);
    setMetodoDePago(data.metodo_de_pago);
    setCalle(data.calle);
    setCP(data.codigo_postal);
    setNumExt(data.numero_exterior);
    setColonia(data.colonia);
    setState(data.estado);
    setCity(data.municipio);
  };

  const onSubmit = (values) => {
    dispatch(updateDataInvoiceCharge(charge.id, groupId, values));
  };

  const handleChangeRFC = (event) => {
    setRfc(event.target.value);
  };

  const handleChangeRazonSocial = (event) => {
    setRazonSocial(event.target.value);
  };

  const handleChangeCalle = (event) => {
    setCalle(event.target.value);
  };

  const handleChangeCP = (event) => {
    setCP(event.target.value);
  };

  const handleChangeNumExt = (event) => {
    setNumExt(event.target.value);
  };

  const handleChangeColonia = (event) => {
    setColonia(event.target.value);
  };

  return (
    <DashboardLayout title={charge.name}>
      <div className={classes.root}>
        <Portlet>
          <PortletHeader>
            <Typography variant="h4">DATOS DE FACTURACIÓN</Typography>
            <Typography variant="h5">{`CARGA: ${charge.name} `} </Typography>
          </PortletHeader>
          <PortletContent noPadding>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
              <Grid2 container={true} spacing={4}>
                <Grid2 size={12}>
                  <div className={classes.fields}>
                    <TextField
                      className={classes.textField}
                      {...register('rfc')}
                      label="RFC"
                      name="rfc"
                      onChange={handleChangeRFC}
                      required
                      value={rfc}
                      variant="outlined"
                    />

                    <TextField
                      className={classes.textField}
                      {...register('razon_social')}
                      label="Razón Social"
                      name="razon_social"
                      onChange={handleChangeRazonSocial}
                      required
                      value={razonSocial}
                      variant="outlined"
                    />

                    <FormControl
                      className={classes.textField}
                      variant="outlined"
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        CFDI
                      </InputLabel>
                      <Select
                        id="demo-simple-select-outlined"
                        {...register('cfdi')}
                        labelId="demo-simple-select-outlined-label"
                        name="cfdi"
                        onChange={handleCFDI}
                        value={cfdi}
                      >
                        {cfdis?.data?.map((item, index) => (
                          <MenuItem value={item.id} key={index}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl
                      className={classes.textField}
                      variant="outlined"
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        Tipo de Pago:
                      </InputLabel>
                      <Select
                        id="demo-simple-select-outlined"
                        {...register('tipo_de_pago')}
                        labelId="demo-simple-select-outlined-label"
                        name="tipo_de_pago"
                        onChange={handlePaymentTypes}
                        value={tipoDePago}
                      >
                        {payment_types?.data?.map((payment_types) => (
                          <MenuItem
                            value={payment_types.id}
                            key={payment_types.id}
                          >
                            {payment_types.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl
                      className={classes.textField}
                      variant="outlined"
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        Metodo de Pago:
                      </InputLabel>
                      <Select
                        id="demo-simple-select-outlined"
                        {...register('metodo_de_pago')}
                        labelId="demo-simple-select-outlined-label"
                        name="metodo_de_pago"
                        onChange={handlePaymentMethods}
                        value={metodoDePago}
                      >
                        {payment_methods?.data?.map((payment_methods) => (
                          <MenuItem
                            value={payment_methods.id}
                            key={payment_methods.id}
                          >
                            {payment_methods.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>

                  <div style={{ marginBottom: '20px', marginTop: '20px' }}>
                    <Typography variant="h4">DOMICILIO FISCAL</Typography>
                  </div>
                  <div>
                    <FormControl
                      className={classes.textField}
                      variant="outlined"
                    >
                      <InputLabel
                        id="demo-simple-select-outlined-label"
                        required
                      >
                        Estado
                      </InputLabel>
                      <Select
                        id="demo-simple-select-outlined"
                        {...register('state')}
                        labelId="demo-simple-select-outlined-label"
                        name="state"
                        onChange={handleChangeState}
                        value={state}
                        //labelWidth={labelWidth}
                      >
                        {estados?.map((el, index) => (
                          <MenuItem value={el} key={index}>
                            {el}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl
                      className={classes.textField}
                      variant="outlined"
                    >
                      <InputLabel
                        id="demo-simple-select-outlined-label"
                        required
                      >
                        Municipio / Ciudad
                      </InputLabel>
                      <Select
                        id="demo-simple-select-outlined"
                        {...register('city')}
                        labelId="demo-simple-select-outlined-label"
                        name="city"
                        onChange={handleChangeCity}
                        value={city}
                        //labelWidth={labelWidth}
                      >
                        {cities?.map((el, index) => (
                          <MenuItem value={el} key={index}>
                            {el}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <TextField
                      className={classes.textField}
                      {...register('calle')}
                      label="Calle"
                      name="calle"
                      onChange={handleChangeCalle}
                      required
                      value={calle}
                      //defaultValue={meter.address}
                      variant="outlined"
                    />

                    <TextField
                      className={classes.textField}
                      {...register('cp')}
                      label="Código Postal"
                      name="cp"
                      onChange={handleChangeCP}
                      value={cp}
                      variant="outlined"
                    />

                    <TextField
                      className={classes.textField}
                      {...register('numExt')}
                      label="Número Exterior"
                      //name="address"
                      name="numExt"
                      onChange={handleChangeNumExt}
                      required
                      value={numExt}
                      variant="outlined"
                    />

                    <TextField
                      className={classes.textField}
                      id="county"
                      {...register('colonia')}
                      label="Colonia"
                      name="colonia"
                      onChange={handleChangeColonia}
                      value={colonia}
                      variant="outlined"
                    />
                  </div>
                </Grid2>
              </Grid2>
              <Button
                className={classes.signUpButton}
                color="secondary"
                //onClick={this.handleSubmit}
                size="large"
                type="submit"
                variant="contained"
              >
                Actualizar
              </Button>
            </form>
          </PortletContent>
        </Portlet>
      </div>
    </DashboardLayout>
  );
}
